import { Box, Button, Container, FormField, Grid, Header, Input, KeyValuePairs, SpaceBetween, SplitPanel, TimeInput } from '@cloudscape-design/components';
import { mdiRayStartArrow } from '@mdi/js';
import Icon from '@mdi/react';
import { differenceInMinutes, parse } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { formatCurrency, minutesToHHMM } from '../../pages/commons/functions';
import { btnDanger, ItemFlight } from '../../resources/types';
import Copy from '../Copy';
import SelectFlightType from '../selects/selectFlightTypes';
import SelectUser from '../selects/selectUser';
import Confirm from './Confirm';



interface SidePanelFlightProps {
    flight: ItemFlight;
    onUpdate?: (updatedFlight: ItemFlight) => void;
    onDelete?: (updatedFlight: ItemFlight) => void;
    editUsers?: boolean;
    editTimes?: boolean;
    editFlight?: boolean;
    showDelete?: boolean;
}

const SidePanelFlightPax: React.FC<SidePanelFlightProps> = ({
    flight, onUpdate, onDelete, editUsers = false, editFlight = false, editTimes = false, showDelete = false,
}) => {



    const [viewDelete, setViewDelete] = useState(false);
    const [newFlight, setNewFlight] = useState<ItemFlight>(flight);
    useEffect(() => {
        setNewFlight(flight)
    }, [flight]);
    return (
        <SplitPanel hidePreferencesButton header={`Detalle de vuelo`} closeBehavior='hide'

            headerActions={<Copy value={newFlight?.idFlight.toString()}></Copy>}
        >
            <SpaceBetween direction="vertical" size="xs">
                <SpaceBetween direction="horizontal" size="xxxs">

                    {newFlight?.jsonSoftMantto?.id && (
                        <>SoftMantto:<Icon path={mdiRayStartArrow} size={1} />{newFlight?.jsonSoftMantto?.id}</>
                    )}
                </SpaceBetween>


                <FormField label="Equipo">
                    <Input value={newFlight?.registration || ""} autoComplete={false} readOnly />
                </FormField>
                <FormField label="Piloto">
                    <SelectUser value={newFlight?.idUserPilot || 0}
                        readonly={!editUsers}
                        filter={newFlight?.equipmentType === "TOW" ? "TOWING" : ``}
                        onConfirm={(user) => {
                            if (user && newFlight)
                                setNewFlight({ ...newFlight, idUserPilot: user?.idUser, userPilot: user?.displayName, });
                            else if (!user && newFlight)
                                setNewFlight({ ...newFlight, idUserPilot: 0, userPilot: "", });
                        }} />
                </FormField>
                <FormField label="Instructor">
                    <SelectUser value={newFlight?.idUserInstructor || 0}
                        readonly={!editUsers}
                        filter={`INSTRUCTOR.${newFlight?.equipmentType}`}
                        onConfirm={(user) => {
                            if (user && newFlight)
                                setNewFlight({ ...newFlight, idUserInstructor: user?.idUser, userInstructor: user?.displayName, });
                            else if (!user && flight)
                                setNewFlight({ ...newFlight, idUserInstructor: 0, userInstructor: "", });
                        }} />
                </FormField>

                <FormField label="Tipo de Vuelo"
                    info={newFlight?.altitude && newFlight?.altitude > 0 ? `Remolque ${newFlight?.altitude}m` : null}>
                    <SelectFlightType value={newFlight?.idFlightType || 0}
                        single
                        readonly={!editFlight}
                        showOnFlightLog={-1}
                        showOnBooking={-1}

                        onSelect={(idFlightType) => {
                            if (idFlightType && idFlightType > 0 && newFlight)
                                setNewFlight({ ...newFlight, idFlightType: idFlightType });
                        }} />
                </FormField>

                <Grid
                    gridDefinition={[{ colspan: 4 }, { colspan: 4 }, { colspan: 4 }]}
                >
                    <div>
                        <FormField label="Salida"
                            constraintText={newFlight?.departureDate}
                        >
                            <TimeInput format="hh:mm" value={newFlight?.departureTime || ""}
                                readOnly={!editTimes}
                                onChange={({ detail }) => {
                                    if (!newFlight) return;
                                    setNewFlight({ ...newFlight, departureTime: detail.value });
                                }} />
                        </FormField>
                    </div>
                    {newFlight && (
                        <div>
                            <FormField label="Llegada"
                                constraintText={newFlight && newFlight?.arrivalDate === newFlight?.departureDate ? "Mismo dia" : newFlight.arrivalDate}>
                                <TimeInput format="hh:mm" value={newFlight?.arrivalTime || ""}
                                    readOnly={!editTimes}
                                    onChange={({ detail }) => {
                                        if (!newFlight) return;
                                        setNewFlight({ ...newFlight, arrivalTime: detail.value });
                                    }} />
                            </FormField>
                        </div>
                    )}
                    <div>
                        <FormField label="Tiempo">
                            <Input value={
                                newFlight?.departureDate.length === 10 && newFlight?.arrivalDate.length === 10 && newFlight?.departureTime.length === 5 && newFlight?.arrivalTime.length === 5 ?
                                    minutesToHHMM(differenceInMinutes(
                                        parse(`${newFlight?.arrivalDate} ${newFlight?.arrivalTime}`, "dd-MM-yyyy HH:mm", new Date()),
                                        parse(`${newFlight?.departureDate} ${newFlight?.departureTime}`, "dd-MM-yyyy HH:mm", new Date())
                                    ))
                                    : null
                            } autoComplete={false} readOnly />
                        </FormField>
                    </div>
                </Grid>
                {newFlight && newFlight.timeCount === "TAC" && (
                    <Grid
                        gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
                    >
                        <div>
                            <FormField label="Hº inicial">
                                <Input type="number" value={newFlight?.tacStart.toString() || "0"}
                                    readOnly={!editTimes}
                                    onChange={({ detail }) => {
                                        if (!newFlight) return;
                                        setNewFlight({ ...newFlight, tacStart: parseFloat(detail.value) });
                                    }} />
                            </FormField>
                        </div>
                        <div>
                            <FormField label="Hº final">
                                <Input type="number" value={newFlight?.tacEnd.toString() || "0"}
                                    readOnly={!editTimes}
                                    onChange={({ detail }) => {
                                        if (!newFlight) return;
                                        setNewFlight({ ...newFlight, tacEnd: parseFloat(detail.value) });
                                    }} />
                            </FormField>
                        </div>
                        <div>
                            <FormField label="Tiempo">
                                <Input
                                    value={
                                        newFlight?.tacEnd && newFlight?.tacStart ?
                                            minutesToHHMM((newFlight.tacEnd - newFlight.tacStart) * 60)
                                            : null}
                                //value={minutesToHHMM(newFlight?.delta || 0)} autoComplete={false} readOnly 
                                />
                            </FormField>
                        </div>
                        <div>
                            <FormField label="Aterrizajes">
                                <Input type="number" value={newFlight?.ciclesLanding.toString() || "0"}
                                    readOnly={!editTimes}
                                    onChange={({ detail }) => {
                                        if (!newFlight) return;
                                        setNewFlight({ ...newFlight, ciclesLanding: parseInt(detail.value) });
                                    }} />
                            </FormField>
                        </div>
                    </Grid>
                )}
                {newFlight?.obs && newFlight?.obs !== "" && (
                    <Container header={<Header variant="h3">Observaciones:</Header>}>
                        {newFlight.obs ?? ""}
                    </Container>
                )}

                <Box>
                    {onUpdate && (showDelete && flight && flight.isClosed === 0) && (
                        <Box float='left'>
                            <Button style={{ root: btnDanger }} onClick={() => {
                                setViewDelete(true);
                            }} >Eliminar</Button>
                        </Box>
                    )}
                    {onUpdate && (editFlight || editTimes || editUsers) && (

                        <Box float='right'>
                            <Button variant='primary' onClick={() => {
                                onUpdate(newFlight)
                            }} >Modificar</Button>
                        </Box>
                    )}
                </Box>
                {newFlight?.idMovement !== 0 && (
                    <Container header={<Header variant="h3">Facturación</Header>}>
                        <KeyValuePairs columns={2}

                            items={[
                                {
                                    label: "Movimiento",
                                    value: newFlight?.idMovement,
                                },
                                {
                                    label: "Cargo",
                                    value: formatCurrency(newFlight?.costReal, "CLP"),
                                }
                            ]}
                        />

                    </Container>
                )}
            </SpaceBetween>

            <Confirm warning="¿Confirma que desea eliminar este vuelo?" type="danger" action="Eliminar"
                onDismiss={() => { setViewDelete(false) }}
                onConfirm={() => {
                    if (onUpdate) {
                        setViewDelete(false)
                        onDelete(newFlight)
                    }
                }}
                show={viewDelete} />
        </SplitPanel >
    );


};

export default SidePanelFlightPax;